import api from '../utils/API';
import { API_URLS } from '../constants/api_urls';

export class OnboardingService {
  static async getOnboardingAll(userId) {
    return await api.get(API_URLS.ONBOARDING_V3, {
      params: userId ? { account_id: userId } : {},
    });
  }

  static async getOnboardingById(id) {
    return await api.get(API_URLS.ONBOARDING_BY_ID(id));
  }

  static async deleteOnboarding(id) {
    return await api.delete(API_URLS.ONBOARDING_BY_ID(id));
  }

  static async getOnboardingForms() {
    return await api.get(API_URLS.ONBOARDING_FORMS_V3);
  }

  static async getOnboardingFormById(data) {
    const { formId, language } = data;
    return await api.get(API_URLS.ONBOARDING_FORMS_BY_ID(formId, language));
  }

  static async createOnboardingSubmission(data) {
    return await api.post(API_URLS.ONBOARDING_V3, data);
  }

  static async startOnboardingEdit(id) {
    return await api.patch(API_URLS.START_ONBOARDING_EDIT_V3(id));
  }

  static async stopOnboardingEdit(id) {
    return await api.patch(API_URLS.STOP_ONBOARDING_EDIT_V3(id));
  }

  static async uploadOnboardingDocument(data) {
    return await api.post(API_URLS.CREATE_FORM_INPUT_ELEMENT_V3, data);
  }

  static async getFormInputElementById(id) {
    return await api.get(API_URLS.GET_FORM_INPUT_ELEMENT_BY_ID_V3(id));
  }

  static async createFormInputElement(data) {
    return await api.post(API_URLS.CREATE_FORM_INPUT_ELEMENT_V3, data);
  }

  static async editFormInputElement(data) {
    const { id, ...rest } = data;
    return await api.put(API_URLS.EDIT_FORM_INPUT_ELEMENT_V3(id), rest);
  }

  static async deleteFormInputElement(id) {
    return await api.delete(API_URLS.EDIT_FORM_INPUT_ELEMENT_V3(id));
  }

  static async createCompositeInputElement(data) {
    return await api.post(API_URLS.CREATE_COMPOSITE_INPUT_ELEMENT_V3, data);
  }

  static async editCompositeInputElement(data) {
    const { id, ...rest } = data;
    return await api.put(API_URLS.EDIT_COMPOSITE_INPUT_ELEMENT_V3(id), rest);
  }

  static async deleteCompositeInputElement(id) {
    return await api.delete(API_URLS.EDIT_COMPOSITE_INPUT_ELEMENT_V3(id));
  }

  static async createFormActionElement(data) {
    return await api.post(API_URLS.CREATE_FORM_ACTION_ELEMENT_V3, data);
  }

  static async submitOnboarding(id) {
    return await api.patch(API_URLS.SUBMIT_ONBOARDING_V3(id));
  }

  static async cancelOnboarding(id) {
    return await api.patch(API_URLS.CANCEL_ONBOARDING_V3(id));
  }
}
